import { Divider } from 'antd';
import React from 'react';
import { ClosingReport } from '~/types/Report';
import { PAYMENT_METHOD_TEXT } from '~/types/Payment';
import { formatCurrency as rawFormatCurrency } from '~/utils/currency';
import CashierInfo from '../CashierInfo';
import MoneyRow from '../MoneyRow';

const formatCurrency = (value: number) => {
  if (value === 0) {
    return value;
  }
  if (value < 0) {
    return `(${rawFormatCurrency(Math.abs(value))})`;
  }
  return rawFormatCurrency(value);
};

const Contents = ({ report }: { report: ClosingReport }) => {
  const divider = <Divider style={{ marginTop: 8, marginBottom: 12 }} />;
  return (
    <div style={{ padding: 16 }}>
      <CashierInfo report={report} />
      {divider}
      <MoneyRow
        leftText="Modal Awal"
        rightText={formatCurrency(report.startBalance)}
        strong
      />
      {divider}
      {report.payments.map(({ method, total }) => (
        <MoneyRow
          key={method}
          leftText={PAYMENT_METHOD_TEXT[method]}
          rightText={formatCurrency(total)}
        />
      ))}
      <MoneyRow
        leftText="Total Pendapatan"
        rightText={formatCurrency(report.totalIncome)}
        strong
        style={{ marginTop: 8 }}
      />
      {divider}
      <MoneyRow
        leftText="Total Rounding"
        rightText={formatCurrency(report.totalRounding)}
        strong
      />
      {divider}
      <MoneyRow
        leftText="Kas Masuk"
        rightText={formatCurrency(report.cashIn)}
      />
      <MoneyRow
        leftText="Kas Keluar"
        rightText={formatCurrency(report.cashOut * -1)}
      />
      {divider}
      <MoneyRow
        leftText="Order Selesai"
        rightText={`${report.closedOrder} order`}
      />
      <MoneyRow
        leftText="Order Belum Selesai"
        rightText={`${report.openOrder} order`}
      />
      <MoneyRow
        leftText="Order Belum Selesai (Rp)"
        rightText={formatCurrency(report.openOrderAmount)}
      />
      {divider}
      <MoneyRow
        leftText="Order Indent Selesai"
        rightText={report.closedOrderIndent}
      />
      <MoneyRow
        leftText="Order Indent Belum Selesai"
        rightText={report.openOrderIndent}
      />
      <MoneyRow
        leftText="Order Indent Terbayar (Rp)"
        rightText={formatCurrency(report.orderIndentReceivedPaymentAmount)}
      />
      <MoneyRow
        leftText="Order Indent Sisa Belum Dibayar (Rp)"
        rightText={formatCurrency(report.orderIndentOutstandingPaymentAmount)}
      />
      <MoneyRow
        leftText="Nilai Total Order Indent (Rp)"
        rightText={formatCurrency(report.orderIndentTotalAmount)}
      />
      <MoneyRow
        leftText="Jumlah Rounding Order Indent (Rp)"
        rightText={formatCurrency(report.orderIndentTotalRoundingAmount)}
      />
      {divider}
      <MoneyRow
        leftText="Total Tunai Sistem"
        rightText={formatCurrency(report.cashBalanceSystem)}
      />
      <MoneyRow
        leftText="Total Tunai Aktual"
        rightText={formatCurrency(report.cashBalanceActual)}
      />
      <MoneyRow
        leftText="Selisih"
        rightText={formatCurrency(report.difference)}
        rightTextStyle={{ color: 'red' }}
        strong
      />
    </div>
  );
};

export default Contents;
